import { render, staticRenderFns } from "./twoLevelModel.vue?vue&type=template&id=3fa6e7fc&scoped=true"
import script from "./twoLevelModel.vue?vue&type=script&lang=js"
export * from "./twoLevelModel.vue?vue&type=script&lang=js"
import style0 from "./twoLevelModel.vue?vue&type=style&index=0&id=3fa6e7fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa6e7fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fa6e7fc')) {
      api.createRecord('3fa6e7fc', component.options)
    } else {
      api.reload('3fa6e7fc', component.options)
    }
    module.hot.accept("./twoLevelModel.vue?vue&type=template&id=3fa6e7fc&scoped=true", function () {
      api.rerender('3fa6e7fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/menuManage/twoLevelModel.vue"
export default component.exports